import { useCallback } from 'react';
import { useLocationInfo } from '../useLocationInfo';
import { LinkClickProps } from '../types/AdobeAnalyticsTypes';

import { AdobeAnalyticsConst } from '../adobeAnalyticsConstants/adobeAnalyticsConstants';
import { useEventTracker } from '../eventTracker/useEventTracker';

export const useLinkClick = () => {
  const locationInfo = useLocationInfo();

  const buildPayload = useCallback(
    (linkClickData: LinkClickProps) => ({
      timestamp: new Date().toISOString(),
      link: {
        url: locationInfo.url,
        domain: locationInfo.hostname,
        path: locationInfo.pathname,
        ...linkClickData,
      },
    }),
    [locationInfo],
  );

  const trackEvent = useEventTracker<LinkClickProps>(AdobeAnalyticsConst.EVENTS.LINKCLICK, buildPayload);

  return { trackLinkClick: trackEvent };
};
